import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, Switch, Route } from 'react-router-dom'
import { DatePicker, Menu, Dropdown } from 'antd'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import { stringifyDate, useListData, useToggle, usePet, useShift } from '../../modules'

import Confirm from '../../components/reusable/confirm'
import Receive from '../../components/reusable/receive'
import Patient from '../../components/reusable/patient'

import NewPatient from '../../components/drawers/newPatient'
import BillPatient from '../../components/drawers/billPatient'
import PatientDetails from '../../components/drawers/patient'
import HospitalBill from '../../components/modals/hospitalBill'
import Ambulance from '../../components/modals/ambulance'
import ConsentOtp from '../../components/modals/consentOtp'
import EligibilityCheckModal from '../../components/drawers/eligibilityCheckModal'

const { RangePicker } = DatePicker

const Patients = () => {
    const [ranges, setRanges] = useState()
    const [chosen, setChosen] = useState([])
    const [categories, setCategories] = useState([])
    const [departments, setDepartments] = useState([])
    const [department, setDepartment] = useState()
    const [ptnt, setPatient] = useState()
    const [string, setString] = useState('')
    const [category, setCategory] = useState('')
    const [selected, setSelected] = useState('')

    const [checkInSelected, setCheckInSelected] = useState('')
    const [selectedPatient, setSelectedPatient] = useState()
    const [selectedScheme, setSelectedScheme] = useState()
    const [billingCandidate, setBillingCandidate] = useState()
    const [billingCategory, setBillingCategory] = useState('')
    const [pendingBillingVisitCheck, setPendingBillingVisitCheck] = useState(false)
    const [preparedVisit, setPreparedVisit] = useState()
    const [pendingClaimCheck, setPendingClaimCheck] = useState(false)
    const [eligibilityDecision, setEligibilityDecision] = useState()
    const [dischargePatient, setDischargePatient] = useState()
    const [activeVisit, setActiveVisit] = useState()
    const [pendingActiveVisitCheck, setPendingActiveVisitCheck] = useState(false)
    const [pendingCashClose, setPendingCashClose] = useState(false)

    const [select, toggleSelect] = useToggle()
    const [billPt, toggleBillPatient] = useToggle()
    const [hospBill, toggleHospitalBill] = useToggle()
    const [amb, toggleAmbulance] = useToggle()
    const [showEligibility, , setShowEligibility] = useToggle()
    const [showOtp, , setShowOtp] = useToggle()
    const [showDischargeOtp, , setShowDischargeOtp] = useToggle()

    const togSelect = () => {
        setChosen([])
        toggleSelect()
    }

    const [
        { loading: pLoading, error: pError, fetch: fetchPatients },
        { list: patients },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('patients', ranges ? { string, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null } : { string }, { notify: true })

    const [{ loading: sLoading, error: sError }] = usePet('routingGroupNames', { hidden: false }, { notify: true, callback: ({ data }) => setCategories(data), logOutOnError: true })

    const { shift } = useSelector(state => state.application)

    const [Shifts, ShiftsModal] = useShift("OPD")

    const [{ loading: mLoading }, merge] = usePet('mergeBills', {
        ids: chosen
    }, {
        notify: true, 
        callback: ({ }, notif, ops) => {
            notif('Bills have been merged', ops('success'))
            fetch()
            togSelect()
        }, 
        manual: true, 
        load: { msg: 'Merging bills...' }
    })

    const [{ loading: dLoading }, deleteBills] = usePet('deleteBills', {
        ids: chosen
    }, {
        notify: true, callback: ({ }, notif, ops) => {
            notif('Bills have been deleted', ops('success'))
            fetch()
            togSelect()
        }, manual: true, load: { msg: 'Deleting bills...' }
    })

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const refresh = () => {
        navigate(1)
        fetchPatients()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const openBillDrawer = (pt, cat) => {
        setCategory(cat)
        setPatient(pt)
        setTimeout(toggleBillPatient, 100)
    }

    const hospitalBill = pt => {
        setPatient(pt)
        toggleHospitalBill()
    }

    const ambulance = pt => {
        setPatient(pt)
        toggleAmbulance()
    }
    
    const onComplete = (_, notif, ops) => {
        notif('Id No has been assigned', ops('success'))
        fetchPatients()
    }

    const [, assignIdNo] = usePet('assignId', {
        patient: selected,
        department
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Assigning ip no...' } })

    usePet('departments', {}, { notify: true, callback: ({ data }) => {
        data = data.filter(dept => dept.requiresId)
        setDepartments(data)
    } })

    const assignId = (id, dept) => {
        setSelected(id)
        setDepartment(dept)
        assignIdNo()
    }

    const onCheckInComplete = (_, notif, ops) => {
        notif('Patient has been checked in', ops('success'))
        setEligibilityDecision(null)
        setSelectedPatient(null)
        setSelectedScheme(null)
        setPreparedVisit(null)
        fetchPatients()
    }

    const [, checkInToTriage] = usePet('checkInToTriage', {
        patient: checkInSelected,
        visit: preparedVisit?._id,
    }, { notify: true, callback: onCheckInComplete, manual: true, load: { msg: 'Checking In Patient...' } })

    const [, ensurePatientVisit] = usePet('ensurePatientVisit', { patient: selectedPatient?._id }, {
        notify: true,
        manual: true,
        callback: ({ data }) => {
            setPreparedVisit(data ?? null)
            setShowOtp(true)
        },
        load: { msg: 'Preparing visit...' },
    })

    const [, fetchPatientSchemes] = usePet('schemesByPatient', { id: selectedPatient?._id }, {
        notify: true,
        manual: true,
        callback: ({ data }) => {
            const schemes = data?.schemes ?? []
            const mainScheme = schemes.find(item => item.main) ?? schemes[0]
            const shaScheme = schemes.find(item => item?.active !== false && item?.scheme?.operatedBy?.isSha)

            setSelectedScheme(shaScheme ?? mainScheme)

            if (shaScheme) {
                setShowEligibility(true)
            } else if (selectedPatient?.beneficiaryCrId) {
                Confirm({
                    title: 'SHA coverage not linked locally',
                    message: 'This patient has a beneficiary CR ID, but no active SHA-linked scheme is attached locally. Continue with a normal visit only if you are certain this should not follow the SHA flow.',
                    okText: 'Continue Normal Visit',
                    onOk: () => performCheckIn(selectedPatient?._id),
                })
            } else {
                performCheckIn(selectedPatient?._id)
            }
        }
    })

    useEffect(() => {
        if (!pendingClaimCheck || !selectedPatient?._id) return

        setPendingClaimCheck(false)
        fetchPatientSchemes()
    }, [pendingClaimCheck, selectedPatient?._id]) // eslint-disable-line react-hooks/exhaustive-deps

    const [, fetchBillingVisit] = usePet('patientActiveVisit', { patient: billingCandidate?._id }, {
        notify: true,
        manual: true,
        callback: ({ data: visit }, notif, ops) => {
            if (!visit) {
                Confirm({
                    title: 'Active visit required',
                    message: 'This patient does not have an active outpatient visit. Check the patient into triage first before billing outpatient items.',
                    okText: 'Check Into Triage',
                    onOk: () => startCheckInFlow(billingCandidate),
                })
                setBillingCandidate(null)
                setBillingCategory('')
                return
            }

            if (visit.shaLinked && !visit.scheme) {
                notif('This active visit is missing scheme context. Re-check the patient into the correct scheme flow before billing.', ops('warning'))
                setBillingCandidate(null)
                setBillingCategory('')
                return
            }

            openBillDrawer(billingCandidate, billingCategory)
            setBillingCandidate(null)
            setBillingCategory('')
        },
    })

    useEffect(() => {
        if (!pendingBillingVisitCheck || !billingCandidate?._id) return

        setPendingBillingVisitCheck(false)
        fetchBillingVisit()
    }, [pendingBillingVisitCheck, billingCandidate?._id]) // eslint-disable-line react-hooks/exhaustive-deps

    const performCheckIn = id => {
        setCheckInSelected(id)
        checkInToTriage({
            patient: id,
            visit: preparedVisit?._id,
        })
    }

    const startCheckInFlow = patient => {
        setSelectedPatient(patient)
        setSelectedScheme(null)
        setPreparedVisit(null)
        setEligibilityDecision(null)
        setPendingClaimCheck(true)
    }

    const billPatient = (pt, cat) => {
        setBillingCandidate(pt)
        setBillingCategory(cat)
        setPendingBillingVisitCheck(true)
    }

    const onEligibilityProceed = decision => {
        setEligibilityDecision(decision ?? null)
        setShowEligibility(false)
        ensurePatientVisit({ patient: selectedPatient?._id })
    }

    const onConsentSuccess = () => {
        setShowOtp(false)
        performCheckIn(selectedPatient?._id)
    }

    const cancelClaimFlow = () => {
        setShowEligibility(false)
        setShowOtp(false)
        setSelectedPatient(null)
        setSelectedScheme(null)
        setPreparedVisit(null)
        setPendingClaimCheck(false)
        setEligibilityDecision(null)
    }

    const [, fetchActiveVisit] = usePet('patientActiveVisit', { patient: dischargePatient?._id }, {
        notify: true,
        manual: true,
        callback: ({ data: visit }, notif, ops) => {
            if (!visit) {
                notif('This patient has no active visit', ops('warning'))
                setDischargePatient(null)
                return
            }

            if (!visit.readyToClose) {
                notif('This visit still has pending items and cannot be closed yet', ops('warning'))
                setDischargePatient(null)
                return
            }

            setActiveVisit(visit)

            if (visit.shaLinked) {
                setShowDischargeOtp(true)
            } else {
                setPendingCashClose(true)
            }
        }
    })

    useEffect(() => {
        if (!pendingActiveVisitCheck || !dischargePatient?._id) return

        setPendingActiveVisitCheck(false)
        fetchActiveVisit()
    }, [pendingActiveVisitCheck, dischargePatient?._id]) // eslint-disable-line react-hooks/exhaustive-deps

    const onCashVisitClosed = (_, notif, ops) => {
        notif('Visit closed', ops('success'))
        setDischargePatient(null)
        setActiveVisit(null)
        fetchPatients()
    }

    const [, closeCashVisit] = usePet('closeCashVisit', { patient: dischargePatient?._id }, {
        notify: true,
        manual: true,
        callback: onCashVisitClosed,
        load: { msg: 'Closing visit...' }
    })

    useEffect(() => {
        if (!pendingCashClose || !dischargePatient?._id) return

        setPendingCashClose(false)
        closeCashVisit()
    }, [pendingCashClose, dischargePatient?._id]) // eslint-disable-line react-hooks/exhaustive-deps

    const onDischargeConsentSuccess = () => {
        setShowDischargeOtp(false)
        setDischargePatient(null)
        setActiveVisit(null)
        fetchPatients()
    }

    const cancelDischargeFlow = () => {
        setShowDischargeOtp(false)
        setDischargePatient(null)
        setActiveVisit(null)
    }

    const startEndVisitFlow = patient => {
        setDischargePatient(patient)
        setActiveVisit(null)
        setPendingActiveVisitCheck(true)
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {
                showEligibility &&
                <EligibilityCheckModal
                    visible={ showEligibility }
                    patient={ selectedPatient }
                    scheme={ selectedScheme }
                    onProceed={ onEligibilityProceed }
                    onCancel={ cancelClaimFlow } />
            }
            {
                showOtp &&
                <ConsentOtp
                    visible={ showOtp }
                    patient={ selectedPatient }
                    scheme={ selectedScheme }
                    visitId={ preparedVisit?._id }
                    mode="visit-start"
                    eligibilitySummary={ eligibilityDecision?.result }
                    overrideSummary={ eligibilityDecision?.override }
                    onSuccess={ onConsentSuccess }
                    onCancel={ cancelClaimFlow } />
            }
            {
                showDischargeOtp &&
                <ConsentOtp
                    visible={ showDischargeOtp }
                    patient={ dischargePatient }
                    visitId={ activeVisit?._id }
                    mode="discharge"
                    onSuccess={ onDischargeConsentSuccess }
                    onCancel={ cancelDischargeFlow } />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Patient Name, OP/IP No." />
                {
                    hospBill &&
                    <HospitalBill
                        onPerform={ refresh }
                        patient={ ptnt }
                        toggle={ toggleHospitalBill }
                        visible={ hospBill } />
                }
                {
                    amb &&
                    <Ambulance
                        onPerform={ refresh }
                        patient={ ptnt }
                        toggle={ toggleAmbulance }
                        visible={ amb } />
                }
                <Receive
                    loading={sLoading}
                    error={sError}>
                        {/* {
                            status &&
                            <Bills
                                shift={ shift }
                                status={ status }
                                categories={ categories }
                                onClose={ () => {
                                    getPending()
                                    setStatus()
                                } }
                                toggle={ toggleBills }
                                visible={ bills }/>
                        } */}
                        {
                            category ?
                            <BillPatient
                                patient={ ptnt }
                                category={ category }
                                categories={ categories }
                                onClose={ () => {
                                    setCategory()
                                    refresh()
                                } }
                                toggle={ toggleBillPatient }
                                visible={ billPt } />
                            : null
                        }
                </Receive>
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <RangePicker 
                        onChange={selectRange}
                        ranges={{
                            'Today': [moment().startOf('day'), moment().endOf('day')],
                            'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                            'This Week': [moment().startOf('week'), moment().endOf('week')],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                        }}/>
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item onClick={() => null}>Patient Visits</Menu.Item>
                            </Menu>
                        }>
                        <button className="btn hisani-btn-green-light ml-2 text-white">
                            <span className="hidden xs:block mr-2">Reports</span>
                            <AiOutlineDown />
                        </button>
                    </Dropdown>
                    <Shifts />
                </div>
            </div>
            { ShiftsModal }
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Patients</h2>
                    <span className="flex items-center justify-between">
                        <Link to="/app/cashier/patients/new">
                            <button className="btn ml-2 hisani-btn-green-light text-white">
                                <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                </svg>
                                <span className="hidden xs:block ml-2">New Patient</span>
                            </button>
                        </Link>
                        <button onClick={refresh} className="btn ml-2 py-3 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        progress
                        loading={pLoading}
                        error={pError}>
                        {
                            patients?.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Added On</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Latest Visit</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                patients.map((patient, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">
                                                                {
                                                                    select ?
                                                                        <input
                                                                            onChange={() => choose(patient._id)}
                                                                            checked={chosen.includes(patient._id)}
                                                                            type="checkbox"
                                                                            className="form-checkbox cursor-pointer h-5 w-5" />
                                                                        :
                                                                        `${((page - 1) * limit) + (key + 1)}.`
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <Patient patient={ patient } />
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{stringifyDate(patient.date)}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{stringifyDate(patient.date)}</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Link to={ `/app/cashier/patients/${patient._id}` }><Menu.Item>Details</Menu.Item></Link>
                                                                        <Menu.Item onClick={ () => Confirm({
                                                                            title: 'Check In Patient?',
                                                                            message: 'Please confirm before proceeding with this action',
                                                                            onOk: () => startCheckInFlow(patient),
                                                                            okText: 'Check In Patient'
                                                                        }) }>Check Into Triage</Menu.Item>
                                                                        <Menu.Item onClick={ () => Confirm({
                                                                            title: 'End Visit?',
                                                                            message: 'This will close the patient\'s current visit. Please confirm before proceeding.',
                                                                            onOk: () => startEndVisitFlow(patient),
                                                                            okText: 'End Visit'
                                                                        }) }>End Visit</Menu.Item>
                                                                        <Link to={ `/app/cashier/patients/${patient._id}?tab=bills` }><Menu.Item>View Current Bill</Menu.Item></Link>
                                                                        {
                                                                            departments
                                                                                .filter(d => !patient[d.idProperty])
                                                                                .map(d =>
                                                                                    <Menu.Item onClick={ () => Confirm({
                                                                                        title: `Assign ${d.name} Id?`,
                                                                                        message: 'Please confirm before performing this action',
                                                                                        okText: `Assign ${d.name} Id?`,
                                                                                        onOk: () => assignId(patient._id, d._id)
                                                                                    }) }>Assign {d.name} Id</Menu.Item>
                                                                                )
                                                                        }
                                                                        {
                                                                            shift &&
                                                                            <>
                                                                                {
                                                                                    categories?.map(category => (
                                                                                        <Menu.Item onClick={() => billPatient(patient, category)}>Bill to { category }</Menu.Item>
                                                                                    ))
                                                                                    
                                                                                }
                                                                                <Menu.Item onClick={ () => hospitalBill(patient) }>Hospital Bill</Menu.Item>
                                                                                <Menu.Item onClick={ () => ambulance(patient) }>Ambulance</Menu.Item>
                                                                            </>
                                                                        }
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">You can add a new patient by clicking above</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
                <Switch>
                    <Route path="/app/cashier/patients/new">
                        <NewPatient
                            path="/app/cashier/patients"
                            onPerform={ refresh } />
                    </Route>
                    <Route path="/app/cashier/patients/:id">
                        <PatientDetails reload={ refresh } source="/app/cashier" />
                    </Route>
                </Switch>
            </div>
        </div>       
    )
}

export default Patients
